var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"size":"sm","title":"Mudar a versão da tela","href":'/' + _vm.rota}},[_c('i',{staticClass:"fa fa-shopping-bag"}),_vm._v(_vm._s(" " + _vm.label)+"\n")])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba5b755a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Orders_v2/TrocarDeProjeto.vue
// module id = AJIG
// module chunks = 0